$('.collapse__menu__primary a').addClass('theme-icon-arrow').prepend('<span class="mr-3 mr-lg-5"><i class="icon icon-arrow-right"></i></span>');

$(document).on('click', '.header__toggle', function () {
  if ($('.modal.active').length != 0) {
    // toggle modal
    $('.modal').removeClass('active');
  }else{
    // toggle collapse
    $('.collapse').toggleClass('active');
  }
  $(this).toggleClass('active');
  $('html').toggleClass('no-scroll');
  
  // Detect if the user is using a mobile device running Android or iOS
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $('.theme-icon-arrow').addClass('platform-is-mobile');
  }
});

$(document).keydown(function (e) {
  if (e.keyCode == 27) {
    if ($('.collapse.active').length != 0) {
      $('.header__toggle').removeClass('active');
      $('.collapse').removeClass('active');
      $('html').removeClass('no-scroll');
    }
  }
});
